<script>
  
  // https://markus.oberlehner.net/blog/dynamic-vue-layout-components/
  
  import Vue from 'vue';

  export default {
    name: 'Layout',
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    created() {
      // Renderless
      // Comprobar si el componente ya se
      // ha registrado para volver a cargarlo cada vez que se cambia 
      // de ruta
      if (!Vue.options.components[this.name]) {
        
        Vue.component(
          this.name,
          () => import(`../../layouts/${this.name}.vue`),
        );
      }

      this.$parent.$emit('update:layout', this.name);
    },
    render() {
      return this.$slots.default[0];
    },
  };
</script>
